export interface SettingsNavItem {
	label: string;
	path: string;
	subject?: string;
	/** Shown only to super admins. */
	superAdminOnly?: boolean;
	/** Shown only to administrators (and super admins), whatever the subject grants. */
	adminOnly?: boolean;
}

export interface SettingsNavGroup {
	heading: string;
	items: SettingsNavItem[];
}

export const settingsNavGroups: SettingsNavGroup[] = [
	{
		heading: 'Tickets',
		items: [
			{ label: 'Ingestion', path: '/settings/ingestion', subject: 'brand' },
			{ label: 'Handling', path: '/settings/handling', subject: 'brand' },
			// OVERFLOW DISABLED — backend gate parked until deferred-send is built
			// { label: 'Ticket Overflow Rules', path: '/settings/overflow', subject: 'brand' },
			{ label: 'Automation', path: '/settings/automation', subject: 'automation' }
		]
	},
	{
		heading: 'General',
		items: [
			{ label: 'Intents', path: '/settings/intents', subject: 'automation' },
			{ label: 'Integrations', path: '/settings/integrations', subject: 'integrations' },
			{ label: 'Escalations', path: '/settings/escalations', subject: 'brand' },
			// Administrators configure Sentinel. A Sentinel holds sentinel-workspace edit to work the
			// queue, but must not see or change these settings.
			{ label: 'Sentinel Workspace', path: '/settings/sentinel-workspace', subject: 'sentinel-workspace', adminOnly: true }
			// { label: 'AI Plan', path: '/settings/ai-plan', subject: 'brand' }
		]
	},
	{
		heading: 'Account',
		items: [
			{ label: 'My Brand', path: '/settings/brand', subject: 'brand' },
			{ label: 'Users & Roles', path: '/settings/users', subject: 'brand' },
			{ label: 'Logs', path: '/settings/logs', subject: 'automation' },
			{ label: 'Developer', path: '/settings/developer', superAdminOnly: true }
		]
	}
];
